import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Grid, useMediaQuery } from '@mui/material';
import InnerContainer from '../../../Common/InnerContainer';
import BackToLink from '../../../Common/BackToLink';
import { useAppDispatch } from '../../../../hooks/redux';
import ClientGroupTitle from '../../../Common/ClientGroupTitle';
import CardInfo from './Setting/CardInfo/CardInfo';
import { cardAPI } from '../../../../services/cardAPI.service';
import { useEffect, useMemo, useState } from 'react';
import { ICards } from '../../../../services/response.interface';
import { useGlobalContext } from '../../../../services/context.service';
import { getMedia } from '../../../../helpers/media';
import CardLimits from './Setting/Limits/CardLimits';
import { fnLocalizeFilter } from '../../../../services/localize.service';
import { cardListAPI } from '../../../../services/cards/fetchCardListByHolderOrAccount.service';
import { getAccountIdFromParams, getCurrentAccountIdFromParams, getHolderIdFromParams } from '../CardList/utils/utils';
import { holderAPI } from '../../../../services/holderAPI.service';

export const initialCardState: ICards = {
  id: '',
  cardId: '',
  cardStatus: false,
  status: 0,
  vin: '',
  activatedDate: '',
  isVirtual: false,
  pinSet: false,
  cardInfo: {
    firstName: '',
    lastName: '',
    mobile: '',
    email: '',
    cabinetEnabled: false,
  },
  firstName: '',
  lastName: '',
  mobile: '',
  email: '',
  cabinetEnabled: false,
  accountId: 0,
  accountRemark: '',
};

export default function CardSetting() {
  /* Получаем языковую локаль */
  const { locale } = useGlobalContext();
  /* Получаем адренсную строку */
  let params = useParams<{ cardId: string, accountId: string, currentAccount: string, holderId: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  /* Управление состоянием */
  const dispatch = useAppDispatch();
  /* Инициализация медиа  */
  const matches = useMediaQuery(getMedia());
  /* Управляем линками */
  let navigate = useNavigate();

  //const [card, setCard] = useState<ICards>(initialCardState);

  /* Получаем список клиентов доступных пользователю */
  const {
    data: dataHolder = { holders: [] },
    isLoading: isLoadingClient,
  } = holderAPI.useFetchAllClientsQuery({ locale });

  const pHolderId = useMemo(() => (getHolderIdFromParams(params, dataHolder.holders)), [params?.holderId, dataHolder.holders.length]);
  const pAccountId = useMemo(() => (getCurrentAccountIdFromParams(params)), [params?.currentAccount]);
  const pCardId = useMemo(() => {return params?.cardId ?? '1';}, [params?.cardId]);

  /* Получаем список карты выбранного счета */
  const {
    data: card = { cardId: '' },
    isLoading: isLoadingCards,
  } = cardAPI.useFetchOneCardByAccountQuery({
    locale,
    cardNo: pCardId,
  });


  /* Получаем все доступные карты  */
  const { data: dataCards = { cards: [] }, isLoading } = cardListAPI.useFetchCardListByHolderOrAccountQuery({
    locale,
    accountId: pAccountId,
    holderId: pHolderId,
  });

  /* Получаем все доступные статусы карт */
  const { data: cardStatuses = { statuses: [] } } = cardAPI.useFetchCardsStatusQuery({ locale });
  /* Получаем все доступные лимиты карт */
  const { data: cardTypeLimits = { types: [] } } = cardAPI.useFetchCardLimitsQuery({ locale });
  /* Получаем все доступные кошельки карт */
  const { data: cardPurses = { purses: [] } } = cardAPI.useFetchCardPursesQuery({ locale });


  useEffect(() => {
    let newCard;

    // if (params && params.holderId && params.cardId && dataCards.cards.length > 0) {
    //   getOneCards({ locale, cardNo: params.cardId })
    //     .then(res => {
    //       /* Выбираем карту после запроса на сервер */
    //       newCard = (res.data && res.data.card) ? res.data.card : initialCardState;
    //       setCard(newCard);
    //     });
    // }
  }, [dataCards.cards, params]);

  const handleClose = () => {
    navigate(`/holder/${params.holderId}/account/${params.currentAccount}/cards?from=${searchParams.get('from')}&page=${searchParams.get('page')}&filter=${searchParams.get('filter')}`, { replace: true });
  };


  return <>
    <InnerContainer direction={'left'} show={true}>
      <BackToLink handleClose={handleClose} backToType={'cards'}>
        <Grid container style={{ flexDirection: 'column' }}>
          <ClientGroupTitle isLoading={isLoadingCards}
                            title={`${fnLocalizeFilter(locale, '_lang.module.cards.titleID')}: ${card.cardId}`}
                            sx={{ marginLeft: `${matches ? '1rem' : '0'}` }} />

          <CardInfo card={card as ICards} cards={dataCards.cards} accountId={pAccountId}
                    statuses={cardStatuses.statuses}
                    holderId={pHolderId} />
          <Grid item xs={12} lg={9} md={11}>
            <CardLimits card={card as ICards} cards={dataCards.cards} cardPurses={cardPurses.purses}
                        cardTypeLimits={cardTypeLimits.types} />
          </Grid>
        </Grid>
      </BackToLink>
    </InnerContainer>
  </>;
}
